import { Lang } from '../../Lang';
import moment from 'moment';
import { Tours as ToursAPI } from '../../Api/Tours';
import { LocationPickerInput } from '../../Widget/LocationPickerInput';
import { LocationPickerModal } from '../../Widget/LocationPickerModal';
import { FormGroup2, FormRow2, Input2, InputType2, LangTextV2, ModalDialog2, ModalDialogType2, SelectBottemBorderOnly2, Switch2, Textarea2 } from 'bambooo';
/**
 * SightingEditModal
 */
export class SightingEditModal extends ModalDialog2 {
    /**
     * constructor
     */
    constructor() {
        super({ id: 'sightingmodaldialog', modalType: ModalDialogType2.large });
        /**
         * id of entry
         * @protected
         */
        this._sightingId = null;
        this._tourId = null;
        this._routeCache = null;
        const bodyCard = jQuery('<div class="card-body"/>').appendTo(this.getBody());
        const rowFirst = new FormRow2({});
        rowFirst.appendTo(bodyCard);
        const groupVehicle = new FormGroup2({ label: new LangTextV2({ text: 'Boat' }) });
        groupVehicle.appendTo(rowFirst.createCol(6));
        this._vehicleSelect = new SelectBottemBorderOnly2(groupVehicle.getElement());
        const groupVehicleDriver = new FormGroup2({ label: new LangTextV2({ text: 'Skipper' }) });
        groupVehicleDriver.appendTo(rowFirst.createCol(6));
        this._vehicleDriverSelect = new SelectBottemBorderOnly2(groupVehicleDriver.getElement());
        const groupbeaufortWind = new FormGroup2({ label: new LangTextV2({ text: 'Wind/Seastate (Beaufort)' }) });
        groupbeaufortWind.appendTo(bodyCard);
        this._beaufortWindSelect = new SelectBottemBorderOnly2(groupbeaufortWind.getElement());
        for (let i = 0; i < 13; i++) {
            this._beaufortWindSelect.addValue({
                key: `${i}`,
                value: `${i}`
            });
            this._beaufortWindSelect.addValue({
                key: `${i}.5`,
                value: `${i}.5`
            });
        }
        const groupDateSight = new FormGroup2({ label: new LangTextV2({ text: 'Date' }) });
        groupDateSight.appendTo(bodyCard);
        this._inputDateSight = new Input2({ type: InputType2.date });
        this._inputDateSight.appendTo(groupDateSight);
        const rowTourTime = new FormRow2({});
        rowTourTime.appendTo(bodyCard);
        const groupTourStart = new FormGroup2({ label: new LangTextV2({ text: 'Start of trip' }) });
        groupTourStart.appendTo(rowTourTime.createCol(6));
        this._inputTourStart = new Input2({ type: InputType2.time });
        this._inputTourStart.appendTo(groupTourStart);
        const groupTourEnd = new FormGroup2({ label: new LangTextV2({ text: 'End of trip' }) });
        groupTourEnd.appendTo(rowTourTime.createCol(6));
        this._inputTourEnd = new Input2({ type: InputType2.time });
        this._inputTourEnd.appendTo(groupTourEnd);
        const rowDurationTime = new FormRow2({});
        rowDurationTime.appendTo(bodyCard);
        const groupDurationFrom = new FormGroup2({ label: new LangTextV2({ text: 'Sighting duration from' }) });
        groupDurationFrom.appendTo(rowDurationTime.createCol(6));
        this._inputDurationFrom = new Input2({ type: InputType2.time });
        this._inputDurationFrom.appendTo(groupDurationFrom);
        const groupDurationUntil = new FormGroup2({ label: new LangTextV2({ text: 'until' }) });
        groupDurationUntil.appendTo(rowDurationTime.createCol(6));
        this._inputDurationUntil = new Input2({ type: InputType2.time });
        this._inputDurationUntil.appendTo(groupDurationUntil);
        const groupPositionBegin = new FormGroup2({ label: new LangTextV2({ text: 'Position begin' }) });
        groupPositionBegin.appendTo(bodyCard);
        this._inputPositionBegin = new LocationPickerInput(groupPositionBegin.getElement(), 'positionbegin');
        const grouPositionEnd = new FormGroup2({ label: new LangTextV2({ text: 'Position end' }) });
        grouPositionEnd.appendTo(bodyCard);
        this._inputPositionEnd = new LocationPickerInput(grouPositionEnd.getElement(), 'positionend');
        this._locationPicker = new LocationPickerModal(jQuery('body'));
        const openPicker = (input, mustBeAfter) => {
            input.setOnRequestPicker((current, accept) => {
                this._locationPicker.resetValues();
                this._locationPicker.open(current, null, (newValue) => {
                    accept(newValue);
                }, mustBeAfter ? mustBeAfter() : null);
                this._loadRouteIntoPicker().catch(() => undefined);
            });
        };
        openPicker(this._inputPositionBegin);
        /*
         * End-picker must come AFTER begin along the route — pass begin's
         * current value at open-time so the picker can warn if the user
         * picks a position the boat passed earlier than the begin.
         */
        openPicker(this._inputPositionEnd, () => this._inputPositionBegin.getGcValue());
        const groupDistanceCoast = new FormGroup2({ label: new LangTextV2({ text: 'Distance to nearest coast (nm)' }) });
        groupDistanceCoast.appendTo(bodyCard);
        this._inputDistanceCoast = new Input2({ type: InputType2.number });
        this._inputDistanceCoast.appendTo(groupDistanceCoast);
        this._inputDistanceCoast.setReadOnly(true);
        const rowPG = new FormRow2({});
        rowPG.appendTo(bodyCard);
        const groupPhotoTaken = new FormGroup2({ label: new LangTextV2({ text: 'Photos taken' }) });
        groupPhotoTaken.appendTo(rowPG.createCol(6));
        this._switchPhotoTaken = new Switch2({});
        this._switchPhotoTaken.appendTo(groupPhotoTaken);
        const groupDistanceCoastEstimationGPS = new FormGroup2({
            label: new LangTextV2({ text: 'Estimation without GPS' })
        });
        groupDistanceCoastEstimationGPS.appendTo(rowPG.createCol(6));
        // this.
        const groupSpecie = new FormGroup2({ label: new LangTextV2({ text: 'Species' }) });
        groupSpecie.appendTo(bodyCard);
        this._specieSelect = new SelectBottemBorderOnly2(groupSpecie.getElement());
        const groupSpeciesCount = new FormGroup2({ label: new LangTextV2({ text: 'Number of animals' }) });
        groupSpeciesCount.appendTo(bodyCard);
        this._inputSpeciesCount = new Input2({ type: InputType2.number });
        this._inputSpeciesCount.appendTo(groupSpeciesCount);
        const groupReaction = new FormGroup2({ label: new LangTextV2({ text: 'Reaction' }) });
        groupReaction.appendTo(bodyCard);
        this._reactionSelect = new SelectBottemBorderOnly2(groupReaction.getElement());
        const groupOther = new FormGroup2({ label: new LangTextV2({ text: 'Other' }) });
        groupOther.appendTo(bodyCard);
        this._inputOther = new Input2({ type: InputType2.text });
        this._inputOther.appendTo(groupOther);
        const groupOtherBoats = new FormGroup2({ label: new LangTextV2({ text: 'Other boats present' }) });
        groupOtherBoats.appendTo(bodyCard);
        this._otherBoats = new Input2({ type: InputType2.text });
        this._otherBoats.appendTo(groupOtherBoats);
        const groupNote = new FormGroup2({ label: new LangTextV2({ text: 'Note' }) });
        groupNote.appendTo(bodyCard);
        this._textareaNote = new Textarea2({});
        this._textareaNote.appendTo(groupNote);
        // buttons -----------------------------------------------------------------------------------------------------
        this.addButtonClose(Lang.i().l('Close'));
        this.addButtonSave(Lang.i().l('Save changes'), true);
    }
    /**
     * getSightingId
     */
    getSightingId() {
        return this._sightingId;
    }
    /**
     * setSightingId
     * @param id
     */
    setSightingId(id) {
        this._sightingId = id;
    }
    setTourId(tourId) {
        if (tourId !== this._tourId) {
            this._routeCache = null;
        }
        this._tourId = tourId;
    }
    async _loadRouteIntoPicker() {
        if (this._tourId === null) {
            return;
        }
        if (this._routeCache === null) {
            const tracking = await ToursAPI.getTrackingList(this._tourId);
            if (!tracking) {
                return;
            }
            const sorted = new Map();
            for (const raw of tracking.positions) {
                try {
                    const pos = JSON.parse(raw);
                    if (pos.timestamp && pos.longitude !== undefined && pos.latitude !== undefined) {
                        sorted.set(pos.timestamp, pos);
                    }
                }
                catch (_a) {
                    /* skip malformed entries — tracking has lots of legacy strings */
                }
            }
            this._routeCache = [...sorted].sort(([a], [b]) => a - b).map(([, v]) => v);
        }
        this._locationPicker.setRoute(this._routeCache);
    }
    /**
     * setVehicleList
     * @param list
     */
    setVehicleList(list) {
        this._vehicleSelect.clearValues();
        this._vehicleSelect.addValue({
            key: '0',
            value: 'Please select a Boat!'
        });
        for (const vehicle of list) {
            this._vehicleSelect.addValue({
                key: `${vehicle.id}`,
                value: vehicle.name
            });
        }
    }
    /**
     * setVehicle
     * @param vehicleId
     */
    setVehicle(vehicleId) {
        this._vehicleSelect.setSelectedValue(`${vehicleId}`);
    }
    /**
     * getVehicle
     */
    getVehicle() {
        return parseInt(this._vehicleSelect.getSelectedValue(), 10) || 0;
    }
    /**
     * setVehicleDriverList
     * @param list
     */
    setVehicleDriverList(list) {
        this._vehicleDriverSelect.clearValues();
        this._vehicleDriverSelect.addValue({
            key: '0',
            value: 'Please select a Skipper!'
        });
        for (const driver of list) {
            this._vehicleDriverSelect.addValue({
                key: `${driver.id}`,
                value: driver.user.name
            });
        }
    }
    /**
     * setVehicleDriver
     * @param driverId
     */
    setVehicleDriver(driverId) {
        this._vehicleDriverSelect.setSelectedValue(`${driverId}`);
    }
    /**
     * getVehicleDriver
     */
    getVehicleDriver() {
        return parseInt(this._vehicleDriverSelect.getSelectedValue(), 10) || 0;
    }
    /**
     * setBeaufortWind
     * @param state
     */
    setBeaufortWind(state) {
        this._beaufortWindSelect.setSelectedValue(`${state}`);
    }
    /**
     * getBeaufortWind
     */
    getBeaufortWind() {
        return this._beaufortWindSelect.getSelectedValue();
    }
    /**
     * setDateSight
     * @param date
     */
    setDateSight(date) {
        this._inputDateSight.setValue(date);
    }
    /**
     * getDateSight
     */
    getDateSight() {
        return this._inputDateSight.getValue();
    }
    /**
     * Set the tour start time.
     * @param {string} time - String time.
     */
    setTourStart(time) {
        this._inputTourStart.setValue(time);
    }
    /**
     * Return the tour start time.
     * @returns {string}
     */
    getTourStart() {
        return this._inputTourStart.getValue();
    }
    /**
     * Set the tour end time.
     * @param {string} time - String time.
     */
    setTourEnd(time) {
        this._inputTourEnd.setValue(time);
    }
    /**
     * Return the tour end time.
     * @returns {string}
     */
    getTourEnd() {
        return this._inputTourEnd.getValue();
    }
    /**
     * Set duration from time.
     * @param {string} time
     */
    setDurationFrom(time) {
        this._inputDurationFrom.setValue(time);
    }
    /**
     * Return the duration from.
     * @returns {string}
     */
    getDurationFrom() {
        return this._inputDurationFrom.getValue();
    }
    /**
     * Set the duration until time.
     * @param {string} time
     */
    setDurationUntil(time) {
        this._inputDurationUntil.setValue(time);
    }
    setPositionBegin(position) {
        this._inputPositionBegin.setValue(position);
    }
    getPositionBegin() {
        return this._inputPositionBegin.getValue();
    }
    setPositionEnd(position) {
        this._inputPositionEnd.setValue(position);
    }
    getPositionEnd() {
        return this._inputPositionEnd.getValue();
    }
    /**
     * Return the duration until.
     * @returns {string}
     */
    getDurationUntil() {
        return this._inputDurationUntil.getValue();
    }
    /**
     * Set the distance to coast input.
     * @param {string} distance
     */
    setDistanceCoast(distance) {
        this._inputDistanceCoast.setValue(distance);
    }
    /**
     * setSpeciesList
     * @param list
     */
    setSpeciesList(list) {
        this._specieSelect.clearValues();
        this._specieSelect.addValue({
            key: '0',
            value: 'Please select a specie!'
        });
        for (const specie of list) {
            if (!specie.isdeleted) {
                this._specieSelect.addValue({
                    key: `${specie.id}`,
                    value: specie.name.split(', ')[0]
                });
            }
        }
    }
    /**
     * setSpecie
     * @param specieId
     */
    setSpecie(specieId) {
        this._specieSelect.setSelectedValue(`${specieId}`);
    }
    /**
     * getSpecie
     */
    getSpecie() {
        return parseInt(this._specieSelect.getSelectedValue(), 10) || 0;
    }
    /**
     * setSpeciesCount
     * @param count
     */
    setSpeciesCount(count) {
        this._inputSpeciesCount.setValue(`${count}`);
    }
    /**
     * getSpeciesCount
     */
    getSpeciesCount() {
        return parseInt(this._inputSpeciesCount.getValue(), 10) || 0;
    }
    /**
     * setReactionList
     * @param list
     */
    setReactionList(list) {
        this._reactionSelect.clearValues();
        this._reactionSelect.addValue({
            key: '-1',
            value: 'Please select a encounter categorie!'
        });
        for (const encounter of list) {
            if (!encounter.isdeleted) {
                this._reactionSelect.addValue({
                    key: `${encounter.id}`,
                    value: encounter.name
                });
            }
        }
    }
    setReaction(reactionId) {
        this._reactionSelect.setSelectedValue(`${reactionId}`);
    }
    /**
     * getReaction
     */
    getReaction() {
        return parseInt(this._reactionSelect.getSelectedValue(), 10) || 0;
    }
    /**
     * Set other information.
     * @param {string} other
     */
    setOther(other) {
        this._inputOther.setValue(other);
    }
    /**
     * Return the other information.
     * @returns {string}
     */
    getOther() {
        return this._inputOther.getValue();
    }
    /**
     * Set other boats is present.
     * @param {string} otherBoats
     */
    setOtherBoats(otherBoats) {
        this._otherBoats.setValue(otherBoats);
    }
    /**
     * Return other boats present.
     * @returns {string}
     */
    getOtherBoats() {
        return this._otherBoats.getValue();
    }
    /**
     * Set the note.
     * @param {string} note
     */
    setNote(note) {
        this._textareaNote.setValue(note);
    }
    /**
     * Return the note.
     * @returns {string}
     */
    getNote() {
        return this._textareaNote.getValue();
    }
    /**
     * resetValues
     */
    resetValues() {
        this.setSightingId(null);
        this.setTourId(null);
        this.setVehicle(0);
        this.setVehicleDriver(0);
        this.setDateSight(moment(new Date()).format('YYYY.MM.DD'));
        this.setTourStart('');
        this.setTourEnd('');
        this.setDurationFrom('');
        this.setDurationUntil('');
        this.setPositionBegin('');
        this.setPositionEnd('');
        this.setDistanceCoast('');
        this.setSpecie(0);
        this.setSpeciesCount(0);
        this.setReaction(-1);
        this.setOther('');
        this.setOtherBoats('');
        this.setNote('');
    }
}
